import { z } from 'zod';
import {
  buildAddressSchema,
  buildInternationalAddressSchema,
} from '../../components/Address/address.schema';
import LangEnum from '../../lang/LangEnum';
import { yupValidateCNPJ } from '../../utils/validators';
import { DocumentType } from '../customer/types/customer.types';
import { TranslateType } from '../translation/translationContext.types';

interface BuildStoreStepSchemaParams {
  translate: TranslateType;
  isInternational: boolean;
}

export const buildStoreStepSchema = ({ translate, isInternational }: BuildStoreStepSchemaParams) =>
  z
    .object({
      location: z.string(),
      countryCode: z.string(),
      stateInscription: z.string().trim(),
      documentType: z.enum(DocumentType).optional(),
      commercialName: z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
      companyName: isInternational
        ? z.string().trim()
        : z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
      cpfcnpj: isInternational
        ? z.string().trim()
        : z
            .string()
            .trim()
            .min(1, translate(LangEnum.GLOBAL_REQUIRED))
            .refine(yupValidateCNPJ, translate(LangEnum.GLOBAL_INVALID_CNPJ)),
      email: z
        .string()
        .trim()
        .min(1, translate(LangEnum.GLOBAL_REQUIRED))
        .pipe(z.email(translate(LangEnum.GLOBAL_INVALID_EMAIL))),
      phone: z.string().trim(),
      address: isInternational
        ? buildInternationalAddressSchema(translate)
        : buildAddressSchema(translate),
    })
    .superRefine((values, context) => {
      const localPhone = values.phone.slice(values.countryCode.length);

      if (!localPhone) {
        context.addIssue({
          code: 'custom',
          path: ['phone'],
          message: translate(LangEnum.GLOBAL_REQUIRED),
        });
      }
    });

export type StoreStepFormValues = z.infer<ReturnType<typeof buildStoreStepSchema>>;
